module.exports = __webpack_public_path__ + "static/media/musictownMobile2.b038566d.png";